import { createFeatureSelector, createSelector } from '@ngrx/store'
import { LoginHistoryState } from './login-history.state'

export const selectLoginHistoryState = createFeatureSelector<LoginHistoryState>('loginHistory')

export const selectAllLoginHistories = createSelector(
  selectLoginHistoryState,
  state => state.loginHistories
)

export const selectLoginHistoryTotalCount = createSelector(
  selectLoginHistoryState,
  state => state.totalCount
)

export const selectLoginHistorySuccessfulCount = createSelector(
  selectLoginHistoryState,
  state => state.successfulLoginCount
)

export const selectLoginHistoryFailedCount = createSelector(
  selectLoginHistoryState,
  state => state.failedLoginCount
)

export const selectLoginHistoryLoggedOutCount = createSelector(
  selectLoginHistoryState,
  state => state.loggedOutLoginCount
)

export const selectLoginHistoryTotalRowCount = createSelector(
  selectLoginHistoryState,
  state => state.totalRowCount
)

export const selectLoginHistoryLoading = createSelector(
  selectLoginHistoryState,
  state => state.loading
)

export const selectLoginHistoryError = createSelector(selectLoginHistoryState, state => state.error)

export const selectLoginHistoryById = (id: string) =>
  createSelector(selectAllLoginHistories, histories =>
    histories.find(history => String(history.id) === String(id))
  )
